import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Rating } from '@codex/basics';
import { formatPrice, formatWasPriceDate } from '@codex/helpers';
import {
  Delivery,
  AvailabilityLinks,
  TickIcon,
  AddToBasketError,
  ErrorText,
  ErrorTextBold,
  InnerContainer
} from './CompareProductStyleTypes';
import AddBasketButtonWithAjaxCall from '../AddToBasket/AddToBasketButtonWithAjaxCall';
import AddToBasketButton from '../AddToBasket/presentionalComponents/AddToBasketButton';
import ProductPriceBlockWrapper, { VARIANT_FO_SITE_COMPARE_POPUP }
  from '../ProductPriceBlock/ProductPriceBlockWrapper';

const Price = ({ val }) => {
  const currentPrice = formatPrice(val.value.currentPrice);
  const savingsPrice = val.value.savingsPrice ? formatPrice(val.value.savingsPrice) : undefined;
  let wasPrice;
  let wasPriceFrom;
  let wasPriceTo;
  if (val.value.wasPrice && val.value.wasPriceFrom && val.value.wasPriceTo) {
    wasPrice = formatPrice(val.value.wasPrice);
    wasPriceFrom = formatWasPriceDate(val.value.wasPriceFrom);
    wasPriceTo = formatWasPriceDate(val.value.wasPriceTo);
  }
  return (
    <ProductPriceBlockWrapper
      variant={VARIANT_FO_SITE_COMPARE_POPUP}
      currentPrice={currentPrice}
      savingsPrice={savingsPrice}
      wasPrice={wasPrice}
      wasPriceFrom={wasPriceFrom}
      fromDateTranslation={'from'}
      wasPriceTo={wasPriceTo}
      toDateTranslation={'to'}
    />
  );
};
Price.propTypes = {
  val: PropTypes.objectOf(PropTypes.any).isRequired
};

export const AddToBasket = ({ val, error }) => {
  const appState = window.appState && window.appState.getState();
  const comparisonProducts = appState && appState.listingPage.comparison.products;
  const comparisonProductsKeyName = comparisonProducts && Object.keys(comparisonProducts)[0];
  const comparisonProductsList = comparisonProducts &&
    comparisonProducts[comparisonProductsKeyName];
  const currentProduct = comparisonProductsList &&
    comparisonProductsList.filter((item) => item.id === val.value)[0];
  const isOutOfStock = currentProduct && currentProduct.isOutOfStock;

  return (
    <>
      {isOutOfStock ? <AddToBasketButton buttonLabel={'Out of Stock'} disabled />
        : (
          <AddBasketButtonWithAjaxCall
            quantity={1}
            buttonLabel={'Add to Basket'}
            fupid={val.value}
          />
        )}
      {
        error && (
        <AddToBasketError>
          <InnerContainer>
            <ErrorText>Failed to update your basket</ErrorText>
            <ErrorTextBold>Please try again</ErrorTextBold>
          </InnerContainer>
        </AddToBasketError>
        )
}
    </>
  );
};

AddToBasket.propTypes = {
  val: PropTypes.objectOf(PropTypes.string).isRequired,
  error: PropTypes.bool
};

AddToBasket.defaultProps = {
  error: false
};

const Availability = () => (
  <span>
    <Delivery>
      <AvailabilityLinks>
        <span className={'available'}>
          <TickIcon icon={'Tick'} />
          {' '}
          FREE delivery available
        </span>
      </AvailabilityLinks>
      <AvailabilityLinks>
        <span>
          <TickIcon icon={'Tick'} />
          {' '}
          Available to Order Online &amp;
          Collect in Store in 1 hour
        </span>
      </AvailabilityLinks>
    </Delivery>
  </span>
);

const CustomerRating = ({ val }) => (
  <Rating
    maxCount={5}
    ratingValue={val.value.averageScore}
    ratingCount={val.value.number}
  />
);
CustomerRating.propTypes = {
  val: PropTypes.objectOf(PropTypes.any).isRequired
};

export default {
  Price,
  AddToBasket,
  Availability,
  CustomerRating
};
